module.exports = __webpack_public_path__ + "static/media/video-yardnapha-on.29c5fc34.png";